import { QRCodeSVG } from 'qrcode.react';
import { CARD_W, CARD_H } from './cardSize';

export default function ModernMinimal({ data, style }) {
  const { groomName, brideName, date, time, venue, address, message: msg, qrValue } = data || {};

  return (
    <div
      className="inv-card"
      style={{
        width: CARD_W, height: CARD_H,
        background: '#FFFFFF',
        border: '2px solid #E0E0E0',
        borderRadius: 10,
        padding: '8mm 10mm',
        fontFamily: "'Inter', 'Segoe UI', sans-serif",
        color: '#1a1a2e',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
        boxSizing: 'border-box',
        ...style,
      }}
    >
      {/* Top accent line */}
      <div style={{
        position: 'absolute', top: 0, left: '20%', right: '20%', height: 4,
        background: 'linear-gradient(90deg, #5F33E1, #8B5CF6, #5F33E1)',
        borderRadius: '0 0 3px 3px',
      }} />

      <div style={{ fontSize: 8.5, letterSpacing: 4, textTransform: 'uppercase', color: '#8B5CF6', marginBottom: 6, fontWeight: 600 }}>
        Taklif
      </div>

      <div style={{ fontSize: 22, fontWeight: 800, color: '#1a1a2e', lineHeight: 1.2, textAlign: 'center' }}>
        {groomName || 'Kuyov'} <span style={{ fontSize: 15, color: '#8B5CF6', margin: '0 6px', fontWeight: 400 }}>&</span> {brideName || "Kelin"}
      </div>

      <div style={{
        width: 46, height: 2.5, margin: '8px 0',
        background: '#5F33E1', borderRadius: 1,
      }} />

      <div style={{ fontSize: 11, textAlign: 'center', lineHeight: 1.6, color: '#444' }}>
        {date && <div style={{ fontWeight: 700, color: '#1a1a2e' }}>{date}</div>}
        {time && <div>{time}</div>}
        {venue && <div style={{ fontWeight: 600, color: '#5F33E1', marginTop: 2 }}>{venue}</div>}
        {address && <div style={{ fontSize: 9.5, color: '#888' }}>{address}</div>}
      </div>

      {msg && (
        <div style={{ fontSize: 8.5, textAlign: 'center', color: '#888', marginTop: 6, maxWidth: '78%' }}>
          {msg}
        </div>
      )}

      {qrValue && (
        <div style={{ position: 'absolute', bottom: '5mm', right: '5mm' }}>
          <QRCodeSVG value={qrValue} size={46} level="M" fgColor="#5F33E1" bgColor="transparent" />
        </div>
      )}

      {/* Bottom accent */}
      <div style={{
        position: 'absolute', bottom: 0, left: '20%', right: '20%', height: 4,
        background: 'linear-gradient(90deg, #5F33E1, #8B5CF6, #5F33E1)',
        borderRadius: '3px 3px 0 0',
      }} />
    </div>
  );
}
